<div class="filter-wrapper">
    <button [disabled]="isDisable" [class.disable]="isDisable" class="button" mat-button [matMenuTriggerFor]="menu"><span>{{label ? label : 'No Label'}}</span><span class="sif sif-chevron-s"></span></button>
    <mat-menu #menu="matMenu" class="matMenu">
        <section class="filter-menu">
            <h3 *ngIf="contentTitle" class="menu-title">{{contentTitle}}</h3>
            <ng-content></ng-content>
        </section>
    </mat-menu>
</div>